import React from "react";

const ErrorShow = (props) => {
  return <p className="errorshow">{props.error ? props.error : ''}</p>;
};

export default ErrorShow;
